import { render } from "./RegistrationPage2.vue?vue&type=template&id=13b9f717&scoped=true"
import script from "./RegistrationPage2.vue?vue&type=script&lang=js"
export * from "./RegistrationPage2.vue?vue&type=script&lang=js"

import "./RegistrationPage2.vue?vue&type=style&index=0&id=13b9f717&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13b9f717"]])

export default __exports__